// src/hooks/useAuth.js
import { useSelector, useDispatch } from 'react-redux';
import { useCallback } from 'react';
import { login, register, logout, clearAuthError } from '../store/actions/authActions';

export const useAuth = () => {
  const dispatch = useDispatch();
  const authState = useSelector((state) => state.auth);

  const handleLogin = useCallback(
    (credentials) => {
      return dispatch(login(credentials));
    },
    [dispatch]
  );

  const handleRegister = useCallback(
    (userData) => {
      return dispatch(register(userData));
    },
    [dispatch]
  );

  const handleLogout = useCallback(() => {
    dispatch(logout());
  }, [dispatch]);

  const handleClearError = useCallback(() => {
    dispatch(clearAuthError());
  }, [dispatch]);

  const handleUpdateProfile = useCallback(
  (userData) => {
    // In a real app, this would dispatch an action to update the profile
    // For now, we'll simulate an API call
    return new Promise((resolve) => {
      setTimeout(() => {
        // Simulate successful profile update
        console.log('Profile updated:', userData);
        resolve(userData);
      }, 1000);
    });
  },
  [dispatch]
);

  return {
    user: authState.user,
    token: authState.token,
    isAuthenticated: authState.isAuthenticated,
    loading: authState.loading,
    error: authState.error,
    login: handleLogin,
    register: handleRegister,
    logout: handleLogout,
    clearError: handleClearError,
     updateProfile: handleUpdateProfile,
  };
};